/**
 * Format an ISO timestamp into short time (e.g., "4:15 PM")
 */
export function formatShortTime(timestamp: string): string {
  try {
    const date = new Date(timestamp);
    return date.toLocaleString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  } catch {
    return '';
  }
}

/**
 * Format an ISO timestamp into a date header (e.g., "February 7, 2026")
 */
export function formatDateHeader(timestamp: string): string {
  try {
    const date = new Date(timestamp);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch {
    return '';
  }
}

/**
 * Get the date key for grouping (e.g., "2026-02-07")
 */
export function getDateKey(timestamp: string): string {
  try {
    const date = new Date(timestamp);
    return date.toISOString().split('T')[0];
  } catch {
    return '';
  }
}

/**
 * Format an ISO timestamp to IST timezone, showing only time in HH:MM format
 * e.g., "04:51" for 04:51 IST
 */
export function formatTimeIST(timestamp: string): string {
  try {
    const date = new Date(timestamp);
    // Convert to IST (UTC+5:30)
    const istDate = new Date(date.getTime() + (5.5 * 60 * 60 * 1000) - (date.getTimezoneOffset() * 60 * 1000));
    const hours = String(istDate.getHours()).padStart(2, '0');
    const minutes = String(istDate.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  } catch {
    return '';
  }
}
/**
 * Format an ISO timestamp to DD/MM/YYYY HH:mm (e.g., "12/02/2026 15:47")
 */
export function formatTransactionDate(timestamp: string): string {
  try {
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  } catch {
    return '';
  }
}